export enum EInvoiceType {
	facture = "facture",
	avoir = "avoir",
}
